import { useState } from "react";
import Swal from "sweetalert2";

import api from "../services/api";
import Navbar from "../components/Navbar";
import { useAuth } from "../context/AuthContext";

function CreateAd() {

  const { token } = useAuth();

  const [imageFile, setImageFile] =
    useState(null);

  const [creating, setCreating] =
    useState(false);

  const [formData, setFormData] =
    useState({

      title: "",
      redirect_url: "",
      position: ""

    });

  const handleChange = (e) => {

    setFormData({

      ...formData,

      [e.target.name]:
        e.target.value

    });

  };

  const uploadImage =
    async () => {

      if (!imageFile) {

        throw new Error(
          "Please select an advertisement image."
        );

      }

      const uploadData =
        new FormData();

      uploadData.append(
        "file",
        imageFile
      );

      uploadData.append(
        "folder",
        "ads"
      );

      const response =
        await api.post(

          "/upload/image",

          uploadData,

          {

            headers: {

              Authorization:
                `Bearer ${token}`,

              "Content-Type":
                "multipart/form-data"

            }

          }

        );

      return response.data.image_url;

    };

  const resetForm = () => {

    setFormData({

      title: "",
      redirect_url: "",
      position: ""

    });

    setImageFile(null);

  };

  const handleSubmit =
    async (e) => {

      e.preventDefault();

      try {

        setCreating(true);

        Swal.fire({

          title:
            "Creating Advertisement...",

          text:
            "Uploading image, please wait.",

          allowOutsideClick:
            false,

          didOpen: () => {

            Swal.showLoading();

          }

        });

        const image_url =
          await uploadImage();

        await api.post(

          "/ads",

          {

            ...formData,

            image_url

          },

          {

            headers: {

              Authorization:
                `Bearer ${token}`

            }

          }

        );

        Swal.fire({

          icon: "success",

          title: "Success",

          text:
            "Advertisement created successfully.",

          timer: 2000,

          showConfirmButton:
            false

        });

        resetForm();

      } catch (error) {

        console.error(error);

        Swal.fire({

          icon: "error",

          title:
            "Creation Failed",

          text:
            error.response?.data
              ?.message ||
            error.message ||
            "Unable to create advertisement."

        });

      } finally {

        setCreating(false);

      }

    };

  return (

    <div>

      <Navbar />

      <div className="form-container">

        <h1>Create Advertisement</h1>

        <form
          onSubmit={handleSubmit}
        >

          <input
            type="text"
            name="title"
            placeholder="Title"
            value={formData.title}
            onChange={handleChange}
            required
          />

          <div
            style={{
              marginTop: "15px",
              marginBottom: "15px"
            }}
          >

            <label>

              <strong>
                Advertisement Image
              </strong>

            </label>

            <input
              type="file"
              accept="image/*"
              onChange={(e) =>
                setImageFile(
                  e.target.files[0]
                )
              }
              required
            />

          </div>

          <input
            type="text"
            name="redirect_url"
            placeholder="Redirect URL"
            value={formData.redirect_url}
            onChange={handleChange}
            required
          />

          <input
            type="text"
            name="position"
            placeholder="Position"
            value={formData.position}
            onChange={handleChange}
            required
          />

          <button
            type="submit"
            disabled={creating}
          >

            {creating
              ? "Creating Advertisement..."
              : "Create Advertisement"}

          </button>

        </form>

      </div>

    </div>

  );

}

export default CreateAd;